import(/* webpackMode: "eager" */ "/app/apps/storefront/src/app/[locale]/error.tsx");
